{
	"accept_invite": {
		"description": "Imposta una password per completare l'attivazione del tuo account.",
		"invalid_link_description": "Contatta il tuo amministratore per richiedere un nuovo invito.",
		"invalid_link_title": "Link di invito non valido",
		"submit": "Attiva account",
		"success": "Account attivato, accedi con la tua nuova password.",
		"title": "Attiva il tuo account"
	},
	"back_to_login": "Torna all'accesso",
	"confirm_password": "Conferma password",
	"cooldown": "Reinvia tra {{seconds}}s",
	"email_placeholder": "Inserisci il tuo indirizzo email",
	"forgot_password": {
		"description": "Inserisci l'indirizzo email del tuo account e ti invieremo un link per reimpostare la password.",
		"email_sent_description": "Controlla la tua email e segui le istruzioni per reimpostare la password.",
		"email_sent_title": "Email inviata",
		"resend": "Invia di nuovo",
		"submit": "Invia link di reimpostazione",
		"title": "Password dimenticata?"
	},
	"log_in": "Accedi",
	"login": {
		"forgot_password": "Password dimenticata?"
	},
	"reset_password": {
		"description": "Scegli una password sicura per proteggere il tuo account",
		"invalid_token": "Questo link di reimpostazione password non è valido o è scaduto.",
		"request_another": "Serve un nuovo link? <requestLink>Richiedi un'altra email di reimpostazione</requestLink>",
		"request_new_link": "Richiedi un nuovo link di reimpostazione",
		"submit": "Reimposta password",
		"title": "Imposta una nuova password"
	},
	"two_factor": {
		"code_sent": "Codice di verifica inviato. Controlla la tua casella di posta.",
		"email_description": "Inserisci il codice a 6 cifre che ti abbiamo inviato via email",
		"methods": {
			"description": "Come vuoi verificare la tua identità?",
			"email_description": "Codice alla tua email",
			"email_title": "Email",
			"recovery_description": "Uno dei tuoi codici di backup",
			"recovery_title": "Codici di backup",
			"title": "Scegli un metodo",
			"totp_description": "Codice dalla tua app",
			"totp_title": "App di autenticazione"
		},
		"recovery_description": "Inserisci uno dei tuoi codici di backup per completare l'accesso",
		"recovery_label": "Codice di backup",
		"resend": "Invia di nuovo il codice",
		"resend_cooldown": "Reinvia tra {{time}}",
		"resend_prompt": "Non hai ricevuto il codice?",
		"title": "Verifica la tua identità",
		"totp_description": "Inserisci il codice a 6 cifre generato dalla tua app di autenticazione",
		"use_another_method": "Usa un altro metodo",
		"verify": "Verifica"
	},
	"validation": {
		"email_invalid": "Inserisci un indirizzo email valido.",
		"otp_length": "Il codice deve essere di 6 cifre.",
		"password_invalid": "Inserisci una password valida.",
		"passwords_mismatch": "Le password non corrispondono.",
		"recovery_code_invalid": "Inserisci un codice di backup."
	}
}
